import axiosV2Instance from './axiosV2Instance';

export interface DeviceModel {
  id: number;
  mac: string;
  status: 'unbound' | 'registered' | 'bound';
  siteId: number | null;
  registeredAt: string | null;
  boundAt: string | null;
}

export const devicesApi = {
  getMyDevices: () =>
    axiosV2Instance.get<DeviceModel[]>('/devices').then(r => r.data),

  seedDevice: (mac: string, deviceSecret: string) =>
    axiosV2Instance.post<{ deviceId: number }>('/devices/seed', { mac, deviceSecret }).then(r => r.data),

  bindDevice: (deviceId: number, siteId: number) =>
    axiosV2Instance.post<{ bound: boolean }>(`/devices/${deviceId}/bind`, { siteId }).then(r => r.data),

  unbindDevice: (deviceId: number) =>
    axiosV2Instance.post<{ unbound: boolean }>(`/devices/${deviceId}/unbind`).then(r => r.data),
};
